<template>
    <div class="vue-block">
        <div class="quick-search-results__wrapper-box">
            <div
                class="quick-search-results__wrapper quick-search-results__wrapper--no-border quick-search-results__wrapper--head">
                <div class="quick-search-results__item-image quick-search-results__item quick-search-results__item--head">
                    Image
                </div>
                <div class="quick-search-results__item quick-search-results__item-multi quick-search-results__item--head">
                    <div
                        class="quick-search-results__item-brand quick-search-results__item quick-search-results__item--head">
                        Brand
                    </div>
                    <div
                        class="quick-search-results__item-product quick-search-results__item quick-search-results__item--head">
                        Product name
                    </div>
                </div>
                <div class="quick-search-results__item-info quick-search-results__item quick-search-results__item--head">
                    Product details
                </div>
                <div class="quick-search-results__item-case quick-search-results__item quick-search-results__item--head">
                    Case pack
                </div>
                <div
                    class="quick-search-results__item-order-details quick-search-results__item quick-search-results__item--head">
                    Previous orders
                </div>
                <div class="quick-search-results__item-price quick-search-results__item quick-search-results__item--head">
                    Price
                </div>
                <div
                    class="quick-search-results__item-quantity quick-search-results__item quick-search-results__item--head">
                    Add to cart
                </div>
            </div>

            <div class="quick-search-results__wrapper quick-search-results__wrapper--no-border"
                v-for="(product, index) in products" :key="index">
                <div class="quick-search-results__item-image quick-search-results__item">
                    <img :src="product.image_quick_reorder" alt="" v-if="product.image_quick_reorder" />
                    <img :src="kadraGlobal.icons + '/src/assets/images/plch.jpg'" alt="" v-else />
                </div>
                <div class="quick-search-results__item quick-search-results__item-multi">
                    <div class="quick-search-results__item-brand quick-search-results__item">
                        <span v-if="product.pa_brand" class="quick-search-results__brand" v-html="product.pa_brand"></span>
                        <span v-else class="quick-search-results__brand">-</span>
                    </div>
                    <div class="quick-search-results__item-product quick-search-results__item">
                        <a class="quick-search-results__product" :href="product.url" v-html="product.title"></a>
                    </div>
                </div>
                <div class="quick-search-results__item-info quick-search-results__item">
                    <span class="quick-search-results__info-size" v-if="product.pa_size && product.pa_color"
                        v-html="product.pa_size + ' | ' + product.pa_color"></span>
                    <span class="quick-search-results__info-size" v-else-if="product.pa_size && !product.pa_color"
                        v-html="product.pa_size"></span>
                    <span class="quick-search-results__info-size" v-else-if="!product.pa_size && product.pa_color"
                        v-html="product.pa_color"></span>
                    <span class="quick-search-results__info-upc" v-html="'SKU: ' + product.sku"></span>
                </div>
                <div class="quick-search-results__item-case quick-search-results__item">
                    <span class="quick-search-results__case" v-if="product.case_pack == 1"
                        v-html="product.case_pack + ' Unit'"></span>
                    <span class="quick-search-results__case" v-else v-html="product.case_pack + ' Units'"></span>
                </div>
                <div class="quick-search-results__item-order-details quick-search-results__item">
                    <span class="quick-search-results__order-details-info"><span>Last Ordered:</span><span> {{
                        dateFormat(product.infoDate) }}</span></span>
                    <span class="quick-search-results__order-details-info"><span>Quantity Ordered (Total):</span>
                        <span>{{ product.infoQty }}</span></span>
                    <template v-if="product.infoOrderLink.length > 0">
                        <span class="quick-search-results__order-details-info" v-for="link in product.infoOrderLink"
                            :key="link"><span>Order #:{{ link }}</span>
                            <a class="quick-search-results__order-details-link" target="_blank"
                                :href="'/invoice?id=' + link">
                                PDF</a>
                        </span>
                    </template>
                    <template v-else>
                        <span class="quick-search-results__order-details-info"><span>Order #:{{ product.infoOrder }}</span>
                            <a class="quick-search-results__order-details-link" target="_blank"
                                :href="'/invoice?id=' + product.infoOrder">
                                PDF</a>
                        </span>
                    </template>
                </div>
                <div class="quick-search-results__item-price quick-search-results__item quick-search-results__item--sale">
                    <span v-if="product.price && product.price_reg !== product.price" class="quick-search-results__price quick-search-results__price--sale" style="text-decoration:line-through">
                        $ {{ parseFloat(product.price_reg).toFixed(2) }}
                    </span>
                    <span v-if="product.price" class="quick-search-results__price">
                        $ {{ parseFloat(product.price).toFixed(2) }}
                    </span>
                    <span v-else class="quick-search-results__price" v-html="'-'"></span>
                </div>
                <div class="quick-search-results__item-quantity quick-search-results__item">
                    <!--todo: move this css into sass file-->
                    <div v-if="!product.price" style="color: #e2401c;display: block;font-size: 12px;font-weight: 600;">
                        <span class="product-info-box__total-quantity-out-icon"></span>
                        <span class="product-info-box__total-quantity-out-text">No price</span>
                    </div>
                    <div class="quick-search-results__quantity-item" v-else>
                        <span @click="
                            removeFromCart(
                                product.ID,
                                index,
                                product.case_pack
                            )
                        "
                            class="quick-search-results__quantity-item-quantity-toggle quick-search-results__quantity-item-quantity--minus"></span>
                        <input
                        :disabled="activeIndex2 === index"
                        class="qty-input-c-adv js-qty-input-c"
                        :data-attr="product.ID"
                        type="text"
                        maxlength="5"
                        :value="GetFormattedQty(product.ID)"
                        ref="inputQy"
                        @keyup="preventHold($event.target, product.ID)" v-on:keyup="onEnter(product.ID, index, product.case_pack)"
                        min="0"
                        placeholder="0"
                        @focus="handleFocus(product.id)"
                        @blur="handleBlur"
                        />
                        <span v-if="checkCart(product)" @click="
                            addToCart(product.ID, index, product.case_pack)
                        "
                            class="quick-search-results__quantity-item-quantity-toggle quick-search-results__quantity-item-quantity--plus"></span>
                    </div>
                    <template v-if="activeIndex2 !== index && product.price">
                        <span v-if="cart[product.ID]"
                            class="cart__items-item-quantity-cases cart__items-item-quantity-cases--has-item">Units in
                            cart</span>
                        <span v-else class="product-info-box__total-cases">Units in cart</span>
                    </template>
                    <span v-if="activeIndex2 === index" class="product-info-box__total-quantity-loader">Processing...</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['products', 'addToCartLoading', 'cart', 'orders'],
    data() {
        return {
            activeIndex2: undefined,
            inputDelay: null,
            kadraGlobal: kadraGlobal,
            CartQty: [],
            AddToCartTimeouts: {}
        };
    },
    watch: {
        addToCartLoading() {
            if (!this.addToCartLoading) {
                this.activeIndex2 = undefined;
            }
        },
        cart() {
            this.UpdateCartQty();
        }
    },
    mounted() {
        if (window.innerWidth < 992 && window.innerWidth > 550) {
            this.equalHeights('quick-search-results__item-image');
            this.equalHeights('quick-search-results__item-product');
            this.equalHeights('quick-search-results__item-order-details');
            this.equalHeights('quick-search-results__item-info');
        }
        this.UpdateCartQty();
    },
    methods: {
        // eslint-disable-next-line no-mixed-spaces-and-tabs
        dateFormat(date) {
            if (date !== undefined) {
                const dateArray = date.split('-');
                return dateArray[1] + '/' + dateArray[2] + '/' + dateArray[0];
            }
        },
        // increase qty
        async addToCart(id, index, pack) {
            this.CartQty[id] = (parseInt(this.CartQty[id]) || 0) + 1;
            this.DelayedUpdateQty(id, index, pack, this.CartQty[id]);
        },
        // decrease qty
        async removeFromCart(id, index, pack) {
            this.CartQty[id] = Math.max(
                0,
                (parseInt(this.CartQty[id]) || 0) - 1
            );
            this.DelayedUpdateQty(id, index, pack, this.CartQty[id]);
        },
        handleFocus(id) {
            this.focusedInput = id;
        },
        handleBlur() {
            this.focusedInput = null;
        },
        preventHold(e, id) {
            const max = 5;
            let val = e.value.replace(/[^0-9]/g, '');
            if (val.length >= max) {
                val = val.slice(0, max);
            }
            document.querySelector(
                `.js-qty-input-c[data-attr="${id}"]`
            ).value = val;
        },
        // on qty input change
        onEnter(id, index, pack) {
            const val = event.target.value.trim() === '' ? 0 : parseInt(event.target.value) || 0;
            if (val < 0) {
                event.target.value = '';
                return false;
            }
            this.CartQty[id] = val;
            this.DelayedUpdateQty(id, index, pack, val);
        },
        checkCart() {
            return true;
        },
        /**
         * @description add equal height to products title
         */
        equalHeights: elName => {
            setTimeout(() => {
                const products = document.getElementsByClassName(elName);
                let x = 0;

                Array.from(products).forEach(el => {
                    el.style.height = 'auto';
                    if (el.offsetHeight > x) {
                        x = el.offsetHeight;
                    }
                });

                Array.from(products).forEach(el => {
                    el.style.height = `${x}px`;
                });
            }, 2000);
        },
        // delayed send qty to WC
        DelayedUpdateQty(ProductId, Index, Pack, Value) {
            if (this.AddToCartTimeouts[ProductId]) {
                clearTimeout(this.AddToCartTimeouts[ProductId]);
            }
            this.AddToCartTimeouts[ProductId] = setTimeout(() => {
                if (Index !== null) {
                    this.activeIndex2 = Index;
                }
                this.$store.dispatch('addMany', {
                    id: ProductId,
                    val: Value,
                    pack: Pack
                });
            }, 500);
        },
        // nice formatted qty value
        GetFormattedQty(ProductId) {
            return this.CartQty[ProductId] === 0 ? '' : (parseInt(this.CartQty[ProductId]) || '');
        },
        // clone qtys from store to local variable
        UpdateCartQty() {
            this.CartQty = { ...this.cart };
        }
    }
};
</script>

<style lang="scss" scoped>
.quick-search-results__price--sale {
    font-size: 11px;
    font-weight: 400;
    font-family: $font-main;
    margin-bottom: 0;
    display: block;
}

.quick-search-results__item--sale {
    flex-direction: column;
    align-items: flex-start;
    padding: 0 0 0 15px;

    @include mq($lg) {
        padding: 0 0 0 20px;
    }
}

.qty-input-c-adv {
    &::placeholder {
        color: $white;
    }

    &:focus {
        &::placeholder {
            color: transparent !important;
        }
    }
}
</style>
